<template>
    <b-container>
        <h2>Task</h2>

        <div class="form-group" :class="{ 'text-danger': validation.hasError('task.subject') }">
            <b-form-input v-model="task.subject" placeholder="Task Subject"></b-form-input>
            <div class="error-message">{{ validation.firstError('task.subject') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('task.description') }">
            <label for="description" class="mt-2">Description</label>
            <ckeditor :editor="editor" v-model="task.description" :config="editorConfig"></ckeditor>
            <div class="error-message">{{ validation.firstError('task.description') }}</div>
        </div>
        <div class="form-group" :class="{ 'text-danger': validation.hasError('task.user_id2') }">
            <label for="user_id2" class="mt-2">Assignee</label>
            <b-form-select v-model="task.user_id2" :options="users" label="Assignee"></b-form-select>
            <div class="error-message">{{ validation.firstError('task.user_id2') }}</div>
        </div>
        <label for="due" class="mt-2">Due Date</label>
        <DatePicker v-model="task.date_due" />
        <label for="opt_estimate" class="mt-2">Estimated Effort</label>
        <b-form-input id="opt_estimate" v-model="task.opt_estimate" type="number"
            placeholder="Estimated Effort"></b-form-input>
        <label for="opt_hours" class="mt-2">Actual Effort</label>
        <b-form-input id="opt_hours" v-model="task.opt_hours" type="number"
            placeholder="Estimated Effort"></b-form-input>
        <label for="ref_status_id" class="mt-2">Status</label>
        <b-form-select v-model="task.ref_status_id" :options="status_codes" label="Status"></b-form-select>
        <label for="ref_importance_id" class="mt-2">Importance</label>
        <b-form-select v-model="task.ref_importance_id" :options="importance_codes" label="Importance"></b-form-select>
        <label for="set_private" class="mt-2">Private Task</label>
        <b-form-select v-model="task.set_private" :options="true_false_codes" label="Private Task"></b-form-select>
        <small>Private tasks will show only on the owner's and assignee's task lists.</small>
        <hr> <b-alert variant="danger" :show="validation.errors.length !== 0">There are validation errors</b-alert>
        <b-button variant="primary" v-if="validation.errors.length === 0" @click="saveTask" class="float-right">Save
            Task</b-button>
    </b-container>
</template>
<script>

import TaskDataService from "@/services/TaskDataService";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReferenceDataService from "@/services/ReferenceDataService";
import UserDataService from '@/services/UserDataService';
import SimpleVueValidation from 'simple-vue-validator';
import DatePicker from '@/components/DatePicker.vue';

const Validator = SimpleVueValidation.Validator;

export default {
    components: {
        DatePicker
    },
    props: ["list"],
    data() {
        return {
            items: [],
            task: {
                subject: '',
                description: '',
                ref_status_id: 1,
                ref_importance_id: 1,
                set_private: 0,
                date_due: '',
                opt_hours: 0,
                opt_estimate: 0,
                user_id2: '',
            },
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
                height: '200px',
            },
            status_codes: [],
            importance_codes: [],
            true_false_codes: [],
            users: [],
            action: 'create'
        };
    },
    validators: {
        'task.subject': function (value) {
            return Validator.value(value).required('The subject is required');
        },
        'task.description': function (value) {
            return Validator.value(value).required('The description is required');
        },
        'task.user_id2': function (value) {
            return Validator.value(value).required('The assignee is required');
        },
    },
    mounted() {
        this.$root.$on('bv::modal::show', () => {
            this.$validate()
        })
    },
    watch: {
        'task.subject': function () {
            this.$validate()
        },
        'task.description': function () {
            this.$validate()
        },
        'task.user_id2': function () {
            this.$validate()
        },
    },
    created() {

        this.importance_codes = ReferenceDataService.importance_codes().map(obj => ({
            value: obj.id,
            text: obj.label
        }));

        this.status_codes = ReferenceDataService.status_codes().map(obj => ({
            value: obj.id,
            text: obj.label + " - " + obj.description
        }));

        this.true_false_codes = ReferenceDataService.true_false_codes();
        UserDataService.getActiveUsers().then((res) => {
            if (res && res.data && Array.isArray(res.data)) {
                this.users = res.data;
            }
        }).catch(() => {
            this.users = [];
        });

        if (this.$route.params.id !== undefined) {
            TaskDataService.getById(this.$route.params.id).then((res) => {
                if (res && res.data) {
                    // Format fields starting with "date_" to YYYY-MM-DD
                    Object.keys(res.data).forEach((key) => {
                        if (key.startsWith("date_") && res.data[key]) {
                            const date = new Date(res.data[key]);
                            if (!isNaN(date)) {
                                const mm = String(date.getMonth() + 1).padStart(2, "0");
                                const dd = String(date.getDate()).padStart(2, "0");
                                const yyyy = String(date.getFullYear());

                                res.data[key] = `${mm}/${dd}/${yyyy}`;
                            }
                        }
                    });
                    this.task = res.data;
                    this.action = 'update';
                }
            }).catch((err) => {
                console.error('Failed to load task:', err);
            });
        }

    },
    methods: {
        saveTask() {
            this.$validate().then((success) => {
                if (!success) {
                    // Validation failed, do not proceed
                    return;
                }

                // Proceed with form submission
                if (this.action === 'update') {
                    TaskDataService.update(this.task.id, this.task).then((res) => {
                        if (res && !res.status) {
                            window.location = `/task/${this.task.id}?update=true`;
                        } else {
                            console.error('Failed to update task:', res?.message);
                        }
                    }).catch((err) => {
                        console.error('Failed to update task:', err);
                    });
                } else {
                    TaskDataService.create(this.task).then((res) => {
                        if (res && res.data && res.data[0] && res.data[0].value) {
                            window.location = `/task/${res.data[0].value}`;
                        } else if (res && res.data && res.data.id) {
                            window.location = `/task/${res.data.id}`;
                        } else {
                            console.error('Failed to create task:', res?.message);
                        }
                    }).catch((err) => {
                        console.error('Failed to create task:', err);
                    });
                }
            });
        }

    }
};

</script>
<style>
.ck.ck-content:not(.ck-comment__input *) {
    height: 300px;
    overflow-y: auto;
}
</style>